import React from "react";

export class AppErrorBoundary extends React.Component {
  state = { err: null };
  static getDerivedStateFromError(err) { return { err }; }
  componentDidCatch(err) { console.error("app crash", err); }
  render() {
    if (!this.state.err) return this.props.children;
    const en = localStorage.getItem("rawaj_lang") === "en";
    return (
      <div className="min-h-screen flex items-center justify-center p-6 text-center" data-testid="app-error">
        <div className="glass rounded-2xl p-8 max-w-md space-y-3">
          <h1 className="text-xl font-bold">{en ? "Something went wrong" : "حدث خطأ غير متوقع"}</h1>
          <p className="text-sm text-muted-foreground">{en ? "Reload the page to continue — your data is saved." : "أعد تحميل الصفحة للمتابعة — بياناتك محفوظة."}</p>
          <button onClick={() => window.location.reload()} className="rounded-full bg-primary text-white px-5 py-2 text-sm font-bold" data-testid="app-error-reload">{en ? "Reload" : "إعادة التحميل"}</button>
        </div>
      </div>
    );
  }
}
